import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import ReactPixel from 'react-facebook-pixel';

const { REACT_APP_TRACKING_FACEBOOK, REACT_APP_TRACKING_GOOGLE, REACT_APP_TYPE } = process.env;
const testMode = (REACT_APP_TYPE !== 'production');

ReactGA.initialize(REACT_APP_TRACKING_GOOGLE, { testMode: testMode });
const advancedMatching = {  };
const options = {
  autoConfig: true,
  debug: testMode,
};
ReactPixel.init(REACT_APP_TRACKING_FACEBOOK, advancedMatching, options);

export default function Analytics(props){
  useEffect(() => {
    if(!testMode){
      ReactGA.send({ hitType: "pageview", page: window.location.pathname });
      ReactPixel.pageView();
    } else {
      console.log(window.location.pathname + window.location.search);
    }
  }, []);

  return <></>;
}